export * from "./global.constants";
export * from "./apiUrls";
export * from "./login/login.constants";
export * from "./unitTestConstants/index";
export * from "./shared/shared.constants";
export * from "./shared/testIds.constants";
export * from "./shared/performanceFilter.constants";
export * from "./shared/report.constants";
export * from "./modalLabels/modalLabels.constants";
export * from "./toastMessages/toastMessages.constants";
export * from "./customerSurvey/customerSurvey.constants";
export * from "./server/response.constants";
export * from "./server/request.constants";
export * from "./googleAnalytics/googleAnalytics.constants";
export * from "./emailVerification/emailVerification.constants";
export * from "./validationMessages/validationMessages.constants";
export * from "./textStrings.constants";
export * from "./reactTable/reactTable.constants";

//Constants used global in the system
export const globalSystemConstants = {
  SELECTED_ROWS: "SELECTED_ROWS",
  REPORT_DOWNLOAD: "REPORT_DOWNLOAD",
  SPINNER_ACTIVATE: "SPINNER_ACTIVATE",
  SPINNER_DIACTIVATE: "SPINNER_DIACTIVATE",
  SET_CONNECTION: "SET_CONNECTION",
  SET_FROM_HUB: "SET_FROM_HUB",
};

export const featureFlagsEnums = {
  INBOX: 1,
  IN_STORE: 2,
  AI_REPLY: 3,
  NPS_FIRST: 4,
};

export const ID = "id";
export const EXACT = "Exact";
export const Svg = "Svg";
export const OR = " OR ";
export const AND = " AND ";
export const emptyString = "";
export const columnNamePrevious = "PREVIOUS";

export const sessionStorageKey = {
  FRANCHISEE__ID: "franchisee__id",
  Rating: "rating",
};

export const paramsConstants = {
  TOKEN: "token",
  FROM_FR: "fromFR",
  BRAND_ID: "brandId",
  LOCATION_ID: "locationId",
  VERIFICATION_TOKEN: "verificationToken",
  ENCRYPTED_PARAMETERS: "encryptedParameters",
  ENCRYPTED_PARAMETERS_EQUALS: "encryptedParameters=",
  CUSTOMER_CONVERSATION_ID: "customerConversationId",
};
